import * as isNumber from 'lodash/isNumber'
import { createSelector } from 'reselect'
import CreditChart, { CreditChartProps } from 'components/features/pfm/CreditChart/CreditChart'
import { Guards } from 'interfaces/guards'
import { connectLoadable } from 'helpers/loadableHelpers'
import { memberInfoGuard } from 'guards/globalGuards'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { captureWarning } from 'helpers/errorHelpers'

const createMapStateToProps = () => createSelector(
  memberInfoSelector,
  (member): CreditChartProps => {
    if (!member) {
      throw createForgottenGuardError('MemberCreditChartContainer', 'memberInfoGuard')
    }
    const { creditscore } = member
    if (!isNumber(creditscore)) {
      captureWarning(`Trying to show MemberCreditChartContainer when member has no creditscore`)
    }

    return {
      memberValue: creditscore,
      peerValue: null,
      otherValue: null,
      showTooltip: true,
      withComparison: true,
    }
  },
)

const memberCreditChartGuards: Guards = [
  memberInfoGuard,
]

const MemberCreditChartContainer = connectLoadable<CreditChartProps>(
  memberCreditChartGuards
)(createMapStateToProps)(CreditChart)
export default MemberCreditChartContainer
